<div class="mediego-toolbar-container" [class.mat-elevation-z4]="applyShadow">
  <mat-toolbar fxLayoutAlign="start center" fxLayoutGap="16px" color="primary">
    <div class="toolbar-logo-section" fxLayout="row" fxLayoutAlign="start center">
      @if (authService.isLoggedIn$ | async) {
        <button mat-icon-button (click)="onMenuButtonClick()">
          <mat-icon>menu</mat-icon>
        </button>
      }
      @if ((authService.isLoggedIn$ | async) === false || (layoutService.isTablet | async) || (layoutService.isDesktop | async)) {
        <div class="logo" fxFlex="0 0 150px">
          <a [routerLink]="['/newsletters']" queryParamsHandling="merge" fxFlex="0 0 100%" fxLayoutAlign="center center">
            <img src="/assets/img/logo/logo-full-white.svg" fxFlex="0 0 100%" alt="logo Mediego">
          </a>
        </div>
      }
      @if ((layoutService.isMobile | async) && (authService.isLoggedIn$ | async)) {
        <div class="logo" fxFlex="0 0 25px">
          <a [routerLink]="['/newsletters']" queryParamsHandling="merge" fxFlex="0 0 100%" fxLayoutAlign="center center">
            <img src="/assets/img/logo/logo-compact-white.svg" fxFlex="0 0 100%" alt="logo Mediego">
          </a>
        </div>
      }
    </div>

    <div class="toolbar-main-section" fxLayout="row" fxLayoutAlign="start center">
      <div fxLayout="row" fxFlex="0 0 100%" fxFlex.gt-lg="1 1 1280px">
        <h3>
          @for (crumb of (displayedBreadcrumbs$ | async); track $index; let last = $last) {
            @if (crumb.engineRedirect || crumb.newslettersRedirect) {
              <a class="clickable" [routerLink]="['/']"
                queryParamsHandling="merge"
                [queryParams]="crumb.newslettersRedirectFilter ? { filter: crumb.newslettersRedirectFilter } : {}">
                {{ crumb.label | translate }}
              </a>
            } @else {
              {{ crumb.label | translate }}
            }
            @if (!last) {
              &nbsp;&nbsp;>&nbsp;&nbsp;
            }
          }
        </h3>
      </div>
    </div>

    <div class="toolbar-end-section">

      <button mat-icon-button [class.shaked]="pendingNotifications$ | async"
        [color]="(pendingNotifications$ | async) === true ? 'warn' : undefined"
        (click)="notificationsOpened = !notificationsOpened" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <mat-icon>{{ (pendingNotifications$ | async) === true ? 'notifications_active' : 'notifications' }}</mat-icon>
      </button>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="notificationsOpened"
        [cdkConnectedOverlayWidth]="600"
        (overlayOutsideClick)="notificationsOpened = false"
        >
        <app-mediego-notifications-card></app-mediego-notifications-card>
      </ng-template>


      <button mat-icon-button [matTooltip]="'MAIN.APP.TOOLBAR.LANGUAGE' | translate" [matMenuTriggerFor]="langMenu">
        <mat-icon>translate</mat-icon>
      </button>
      <mat-menu #langMenu="matMenu" class="language-selection-menu">
        @for (lang of availableLanguages; track lang) {
          <button mat-menu-item
            [class.active]="(selectedLanguage$ | async) === lang"
            [disabled]="(selectedLanguage$ | async) === lang"
            (click)="setLanguage(lang)">
            {{ langDisplayName(lang) }}
          </button>
        }
      </mat-menu>

      <a mat-icon-button [matTooltip]="'MAIN.APP.TOOLBAR.DOCS' | translate"
        [href]="docHref$ | async" target="_blank" rel="noopener"
        data-intercom-target="documentation_link">
        <mat-icon>import_contacts</mat-icon>
      </a>

      @if ((authService.isLoggedIn$ | async) && (hasModulePermission('supportEnLigne'))) {
        <app-mediego-intercom
          data-intercom-target="intercom_link">
        </app-mediego-intercom>
      }
    </div>
  </mat-toolbar>

  @if (tabRoutes?.length) {
    <nav mat-tab-nav-bar [hidden]="tabRoutes.length === 0" [tabPanel]="tabPanel">
      @for (route of tabRoutes; track route.path) {
        @if (route.visible) {
          <a mat-tab-link fxFlex="auto"
            [routerLink]="route.path"
            queryParamsHandling="preserve"
            routerLinkActive="active"
            #rla="routerLinkActive"
            [active]="rla.isActive"
            [attr.data-intercom-target]="route.intercomTag">
            <mat-icon>{{route.icon}}</mat-icon>
            @if ((layoutService.isDesktop | async) && (layoutService.isLandscape | async)) {
              <span>
                {{ route.label | translate }}
              </span>
            }
          </a>
        }
      }
    </nav>
  }
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

</div>
